import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import reduce from 'lodash/reduce'
import each from 'lodash/each'

type PinnedMap = Record<string, string>

interface PinnedState {
  nodes: PinnedMap
}

interface PinnedAction {
  type?: string
  payload?: {
    id?: string
    ids?: string[]
  }
}

const initialState: PinnedState = {
  nodes: {},
}

const pinned = (state: PinnedState = initialState, action: PinnedAction): PinnedState => {
  switch (action.type) {
    case actionTypes.NODES.ONE.PIN:
      if (!action.payload?.id) return state
      return defaultsDeep(
        {
          nodes: {
            [action.payload.id]: action.payload.id
          }
        },
        state
      )
    case actionTypes.NODES.ONE.UNPIN: {
      if (!action.payload?.id) return state
      const updated = cloneDeep(state)
      delete updated.nodes[action.payload.id]
      return updated
    }
    case actionTypes.NODES.MULTI.PIN:
      return {
        nodes: reduce(action.payload?.ids ?? [], (ps: PinnedMap, id: string) => {
          return defaultsDeep(
            {
              [id]: id
            },
            ps
          )
        }, state.nodes)
      }
    case actionTypes.NODES.MULTI.UNPIN: {
      const updated = cloneDeep(state)
      each(action.payload?.ids ?? [], (id: string) => {
        delete updated.nodes[id]
      })
      return updated
    }
    default:
      return state
  }
}

export default pinned
